<div class="footer-bottom ph-footer shade-{{ shade }}">
  <span class="py-3 px-5 d-flex justify-content-center"
    >&copy;{{ currentYear }}&nbsp;<span i18n>Princess House, Inc. All Rights Reserved</span></span
  >
</div>
